import React, { createContext, useContext, useState } from "react";
import AlertBox from "../../components/AlertBox/AlertBox";

const AlertContext = createContext();

export const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState({
    show: false,
    message: "",
    handlecancel: null,
    enableSuccessIcon: false,
    enableFailIcon: false,
    enableWarningIcon: false,
    autoHide: false,
  });

  const showAlert = (message, options = {}) => {
    setAlert({
      show: true,
      message,
      handlecancel: options?.handlecancel || (() => hideAlert()),
      enableSuccessIcon: options?.enableSuccessIcon || false,
      enableFailIcon: options?.enableFailIcon || false,
      enableWarningIcon: options?.enableWarningIcon || false,
      autoHide: options?.autoHide || false,
    });
    if (options.autoHide) {
      setTimeout(() => {
        hideAlert();
      }, 5000);
    }
  };

  const hideAlert = () => {
    setAlert((prev) => ({ ...prev, show: false }));
  };

  return (
    <AlertContext.Provider value={{ showAlert, hideAlert }}>
      {children}
      <AlertBox
        show={alert.show}
        message={alert.message}
        handlecancel={alert.handlecancel}
        enableSuccessIcon={alert.enableSuccessIcon}
        enableFailIcon={alert.enableFailIcon}
        enableWarningIcon={alert.enableWarningIcon}
      />
    </AlertContext.Provider>
  );
};

export const useAlert = () => useContext(AlertContext);
